import smoothscroll from 'smoothscroll-polyfill';

export default function scrollToElement(elementId) {
  smoothscroll.polyfill();
  const headerHeight = document.querySelector('header').scrollHeight;
  const offset = document.getElementById(elementId).offsetTop;
  window.scrollTo({
    top: offset - headerHeight,
    behavior: 'smooth',
  });
}
